<template>
    <div id="stepSixForm" class="step-form">
        <h3 class="mb-5">
            Permit Type:
            <small>{{formType === 'grid' ? 'Grid (city all)' : 'Film permit'}}</small>
        </h3>
        <section>
            <div>
            <h2>
                Business details
                <span class="float-right">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        @click="$emit('changeStep',1)"
                    >Edit</button>
                </span>
            </h2>
            
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-subheading">Location manager</div>
                    <p>
                        <strong>{{manager.name}}</strong>
                        <br />
                        {{manager.phone}}
                        <br />
                        {{manager.email}}
                    </p>
                </div>
                <div class="col-lg-6">
                    <div class="form-subheading">Production company</div>
                    <p>{{formData.CompanyName}}</p>
                    <p>
                        {{formData.CompanyAddressLine1}}
                        <br v-if="formData.CompanyAddressLine2" />
                        {{formData.CopmanyAddressLine2 ? formData.CopmanyAddressLine2 : null}}
                        <br />
                        {{formData.CompanyCity+ ', ' + formData.CompanyProvince }}
                        <br />
                        {{formData.CompanyPostalCode}}
                    </p>
                    <p>{{formData.CompanyPhone}}</p>
                    <p>{{formData.CompanyEmail}}</p>
                </div>
            </div>
        </section>
        <section>
            <h2>
                Production information
                <span class="float-right">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        @click="$emit('changeStep',2)"
                    >Edit</button>
                </span>
            </h2>
            <p>
                <strong>Title:</strong>
                {{formData.ProductionTitle}}
            </p>
            <p>
                <strong>Production type:</strong>
                {{filmTypes[formData.ProductionType]}}
            </p>
            <p v-if="formData.ProductionType_EpisodeNumber">
                <strong>Episode number:</strong>
                {{formData.ProductionType_EpisodeNumber}}
            </p>
            <p v-if="formData.ProductionType_Other">
                <strong>Description:</strong>
                {{formData.ProductionType_Other}}
            </p>
            <p>
                <strong>Shoot from</strong>
                {{formData.Filming_StartDate}}
                <strong>to</strong>
                {{formData.Filming_EndDate}}
            </p>

            <p>
                <strong>Weather date:</strong>
                {{formData.Weather_Date}}
            </p>
            <p v-if="formData.Prep_StartDate">
                <strong>Prep from</strong>
                {{formData.Prep_StartDate}}
                <strong>to</strong>
                {{formData.Prep_EndDate}}
            </p>
            <p v-if="formData.Wrap_StartDate">
                <strong>Wrap from</strong>
                {{formData.Wrap_StartDate}}
                <strong>to</strong>
                {{formData.Wrap_EndDate}}
            </p>
            <p>
                <strong>Vehicles:</strong>
                {{formData.NumOfVehicles}}
            </p>
            <p>
                <strong>Cast and crew:</strong>
                {{formData.NumOfCastCrew}}
            </p>
            <p>
                <strong>Total budget:</strong>
                ${{formData.TOTALPRODBUDGET}} {{formData.TOTCADCB == 'Y' ? 'CAD' : 'USD'}}
            </p>
            <p>
                <strong>Estimated spend in Mississauga:</strong>
                ${{formData.ESTSPEND}} {{formData.ESTCADCB == 'Y' ? 'CAD' : 'USD'}}
            </p>
            <p>
                <strong>We will inlude the City of Mississauga in our credits:</strong>
                {{formData.Consent_CityCredit == 'Y' ? 'Yes' : 'No'}}
            </p>
        </section>
        <section>
            <h2>
                Filming details
                <span class="float-right">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        @click="$emit('changeStep',3)"
                    >Edit</button>
                </span>
            </h2>
            <div
                v-if="formData.EQRW == 'Y' ||
		formData.EQBLVD == 'Y' ||
		formData.EQSW == 'Y' ||
		formData.CAMCAR == 'Y' ||
		formData.TOWRIG == 'Y'"
            >
                <p>
                    <strong>Camera equipment:</strong>
                </p>
                <ul>
                    <li v-if="formData.EQRW == 'Y'">On the road</li>
                    <li v-if="formData.EQBLVD == 'Y'">On boulevard</li>
                    <li v-if="formData.EQSW == 'Y'">On sidewalk</li>
                    <li v-if="formData.CAMCAR == 'Y'">In a vehicle</li>
                    <li v-if="formData.TOWRIG == 'Y'">In a tow rig</li>
                </ul>
            </div>
            <div
                v-if="formData.FILMINTERIOR == 'Y' ||
		formData.FILMEXT == 'Y' ||
		formData.FILMFRONT == 'Y' ||
		formData.FILMBACK == 'Y' ||
		formData.FILMOTHER == 'Y'"
            >
                <p>
                    <strong>Filming in:</strong>
                </p>
                <ul>
                    <li v-if="formData.FILMINTERIOR == 'Y'">Interior</li>
                    <li v-if="formData.FILMEXT == 'Y'">Exterior</li>
                    <li v-if="formData.FILMFRONT == 'Y'">Front</li>
                    <li v-if="formData.FILMBACK == 'Y'">Backyard</li>
                    <li v-if="formData.FILMOTHER == 'Y'">Other</li>
                </ul>
            </div>
            <p v-if="formData.VEHPULLLOC">
                <strong>Pull up/Pull away location:</strong>
                {{formData.VEHPULLLOC}}
            </p>
            <p v-if="formData.TRVSHOTLOC">
                <strong>Travelling shot location:</strong>
                {{formData.TRVSHOTLOC}}
            </p>
            <p v-if="formData.POLSTOPLOC">
                <strong>Traffic stoppage location:</strong>
                {{formData.POLSTOPLOC}}
            </p>
            <p v-if="formData.SPFXDESC">
                <strong>Special effects being used:</strong>
                <br />
                {{formData.SPFXDESC}}
            </p>
            <p v-if="formData.UAV == 'Y'">
                <strong>UAV:</strong>Yes
            </p>
            <p v-if="formData.SPECINSTR">
                <strong>Other information:</strong>
                <br />
                {{formData.SPECINSTR}}
            </p>
        </section>
        <section v-if="formType !== 'grid'">
            <h2>
                Filming locations
                <span class="float-right">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        @click="$emit('changeStep',4)"
                    >Edit</button>
                </span>
            </h2>
            <div v-if="formData.Facility_Building_Name">
                <p>{{formData.Facility_Building_Name}}</p>
                <p>From: {{formData.Facility_Building_StartDate}} To: {{formData.Facility_Building_EndDate}}</p>
            </div>

            <div v-if="formData.Facility_Park_Name">
                <p>{{formData.Facility_Park_Name}}</p>
                <p>From: {{formData.Facility_Park_StartDate}} To: {{formData.Facility_Park_EndDate}}</p>
            </div>

            <div v-if="formData.SelectedFilmingLocationList[0].AddressName">
                <strong>Private Address {{formData.SelectedFilmingLocationList[1].AddressName ? '1' : null}}</strong>
                <p>{{formData.SelectedFilmingLocationList[0].AddressNumber}} {{formData.SelectedFilmingLocationList[0].AddressName}}</p>
            </div>

            <div v-if="formData.SelectedFilmingLocationList[1].AddressName">
                <strong>Private Address 2</strong>
                <p>{{formData.SelectedFilmingLocationList[1].AddressNumber}} {{formData.SelectedFilmingLocationList[1].AddressName}}</p>
            </div>
        </section>

        <section v-if="formType !== 'grid'">
            <h2>
                Parking lots and roads
                <span class="float-right">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        @click="$emit('changeStep',5)"
                    >Edit</button>
                </span>
            </h2>
            <div id="locations-container">
                <LocationCard
                    class="card"
                    v-for="(location, index) in parkingLocations"
                    :location="location"
                    :index="index"
                    :key="'location-'+index"
                    :review="true"
                />
            </div>
        </section>
        <section>
            <h4>Terms and conditions</h4>

            <p>Personal information on this form is collected under the authority of Section 11 of the Municipal Act, 2001 and the City of Mississauga Policy No. 06-03-02. The information will be used to process applications and in public notices to the community. Questions about this collection should be directed to the City of Mississauga, Supervisor, Film &amp; Television, 300 City Centre Drive, Mississauga ON L5B 3C1 Tel: 905-615-3200, ext. 6150. E-mail: film.office@mississauga.ca</p>
        </section>
        <div class="form-row">
            <CheckboxInput
                inputId="Agreement"
                v-model="Agreement"
                labelText="I have read and agree to the terms and conditions."
                :labelAfter="true"
                :inline="true"
                v-if="!loading"
            />
        </div>
        <!-- <div class="d-flex justify-content-end mb-3">
            <vue-recaptcha
                sitekey="6LePGyYTAAAAAHF6DUmTXY-DhX4d931Njqs1_zEY"
                @verify="recaptchaVerify"
                @expire="recaptchaIsValid = false; recaptchaToken = '';"
            ></vue-recaptcha>
        </div>-->
        <div
            class="alert alert-danger mt-3"
            v-if="!Agreement && submitted"
        >You must agree to the terms and conditions to submit the form.</div>
        <div class="d-flex justify-content-begin align-items-end">
            <button
                id="nextStep"
                class="mt-3 btn btn-primary"
                @click="submitApplication"
                v-if="!loading"
            >Submit</button>
            <!-- <div
                class="my-3 alert alert-danger"
                v-if="submitted && !recaptchaIsValid"
            >Please confirm the recaptcha box.</div>-->
            <div class="spinner-container ml-3 mt-5" v-if="loading">
                <div class="spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
import LocationCard from "@/components/LocationCard.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
// import VueRecaptcha from "vue-recaptcha";

export default {
    name: "step-6",
    components: {
        LocationCard,
        CheckboxInput
        // VueRecaptcha
    },
    data() {
        return {
            step: 6,
            submitted: false,
            // recaptchaIsValid: false,
            recaptchaToken: "",
            filmTypes: {
                FILM01: "Commercial",
                FILM02: "Feature",
                FILM03: "Mini Series",
                FILM04: "Music Video",
                FILM05: "Student",
                FILM06: "TV Movie",
                FILM07: "TV Series",
                FILM08: "TV Special",
                FILM09: "Web Series",
                FILM10: "Other"
            }
        };
    },
    computed: {
        formData() {
            return this.$store.state.formData;
        },
        manager() {
            const {
                FirstName,
                LastName,
                Phone,
                Email
            } = this.$store.getters.getUser;
            return {
                name: FirstName + " " + LastName,
                phone: Phone,
                email: Email
            };
        },
        Agreement: {
            get() {
                return this.$store.state.formData.Agreement == "Y"
                    ? true
                    : false;
            },
            set(value) {
                if (value) {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: "Agreement",
                        data: "Y"
                    });
                } else {
                    this.$store.dispatch("", {
                        field: "Agreement",
                        data: "N"
                    });
                }
            }
        },
        parkingLocations() {
            return this.$store.getters.getParkingLocations;
        },
        loading() {
            return this.$store.getters.isLoading;
        },
        formType() {
            return this.$store.getters.formType;
        }
    },
    methods: {
        submitApplication() {
            this.submitted = true;
            // RECAPTCHA LOGIC
            // if (this.Agreement && this.recaptchaIsValid) {
            //     this.$store
            //         .dispatch("SUBMIT_APPLICATION", this.recaptchaToken)
            //         .then(() => {
            //             this.$router.push("application-submitted");
            //         });
            // }

            if (this.Agreement) {
                this.$store
                    .dispatch("SUBMIT_APPLICATION", this.recaptchaToken)
                    .then(() => {
                        this.$router.push("application-submitted");
                    });
            }
        }
        // recaptchaVerify(evt) {
        //     this.recaptchaToken = evt;
        //     this.recaptchaIsValid = true;
        // }
    }
};
</script>
